// TEN11-F2 (DEC-407): the in-app notice. While a franchisor has a support session open at this customer, every signed-in
// screen shows "Support session open: <franchisor name>" above the app, so the people at the location know someone is in
// their instance. Asks GET .../support-notice once a minute while a staff session exists; says nothing when none is
// live or the read fails. Not shown in a support tab (that has its own Support session location). Text by textContent.

import { getSupportNotice } from "./api.ts";
import { isSupportPage } from "./supportEntry.ts";
import { loadSession } from "./session.ts";

const POLL_MS = 60_000;
const NOTICE_ID = "support-notice";

export function noticeText(names: readonly string[]): string {
  return `Support session open: ${names.join(", ")}`;
}

async function refresh(): Promise<void> {
  const shell = document.getElementById("app-shell");
  const session = loadSession();
  const existing = document.getElementById(NOTICE_ID);
  if (shell === null || session === undefined || isSupportPage(window.location.pathname)) {
    existing?.remove();
    return;
  }
  const reply = await getSupportNotice(session.apiBaseUrl, session.tenantId);
  const names = reply.status === 200 ? (reply.body.franchisors ?? []) : [];
  if (names.length === 0) {
    existing?.remove();
    return;
  }
  const node = existing ?? document.createElement("div");
  node.id = NOTICE_ID;
  node.className = "support-bar";
  node.dataset["testid"] = NOTICE_ID;
  node.setAttribute("role", "status");
  node.textContent = noticeText(names);
  if (existing === null) shell.prepend(node);
}

let started = false;
/** Starts the minute poll once per page. */
export function startSupportNotice(): void {
  if (started) return;
  started = true;
  void refresh();
  window.setInterval(() => void refresh(), POLL_MS);
  window.addEventListener("focus", () => void refresh());
}
